import { Component, OnInit } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import * as moment from 'moment';


@Component({
    selector: 'app-home',
    templateUrl: 'home.component.html'
})

export class HomeComponent implements OnInit, AfterViewInit {


    constructor() { }

    ngOnInit() { }

    ngAfterViewInit() {

    }
}



// WEBPACK FOOTER //
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/app/home/home.component.ts